import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &&& svg {
    transform: scale(0.75);
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& svg {
      transform: scale(1);
    }
  }
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  ${pickThemeFontStyles('12', '12', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
  }
`;

export const StyledChartWrapper = styled.div`
  width: 100%;
  height: 40rem;
  display: flex;
  flex-direction: column-reverse;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    height: 50rem;
    flex-direction: row;
  }
`;

export const StyledSummaryBlock = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 1rem;
  gap: 3.5rem;
  border-radius: 0.375rem;
  background: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    width: 13rem;
    flex-direction: column;
    gap: 2rem;
  }
`;

export const StyledSummaryContentItem = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const StyledSummaryTitle = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.WHITE};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('12', '16', 'NORMAL')};
  }
`;

export const StyledSummaryValue = styled.div`
  ${pickThemeFontStyles('18', '22', 'NORMAL')};
  color: ${COLORS.YELLOW_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('28', '22', 'BOLD')};
  }
`;
